import { IFilterSection } from "@faire/web-api/indigofair/data/IFilterSection";
import { getFilterOptions } from "@faire/retailer-shared/filters/getFilterOptions";
import { useMemo } from "react";

import { useSearchPageFilteredFilterSections } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageFilteredFilterSections";
import { useSearchPageFilters } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageFilters";

export const useSearchPageFilterKeys = () => {
  const filters = useSearchPageFilters();
  const filterSections = useSearchPageFilteredFilterSections();
  return useMemo(() => {
    const options = getFilterOptions(
      filterSections.filter(
        (section) => section.field_name !== IFilterSection.FieldName.SORTING
      )
    );
    return options.length > 0
      ? options
          .filter((option) => option.is_selected)
          .map((option) => option.key!)
      : filters;
  }, [filterSections, filters]);
};
